module.exports = __webpack_public_path__ + "img/service-1.b5b04b6a.svg";